import { useMemo } from 'react';

import { ScannerStatus } from '@rtkwlf/rendall';

export const useGetEditableStatus = (scannerStatus?: ScannerStatus) => {
  return useMemo(() => {
    switch (scannerStatus) {
      case ScannerStatus.New:
      case ScannerStatus.Scanning:
      case ScannerStatus.Connected:
      case ScannerStatus.Idle:
      case ScannerStatus.Disconnected:
      case ScannerStatus.Degraded:
      case ScannerStatus.Staged:
      case ScannerStatus.AwaitingActivation:
      case ScannerStatus.Misconfigured:
        return true;
      default:
        return false;
    }
  }, [scannerStatus]);
};
